import { DATE_FORMATS, formatDateToUI } from '@dealstack/shared/lib/format/dates/date.ts';
import { SECURITY_NOMINAL_VALUE_PRECISION } from '@dealstack/frontend/shared/cap.ts';

interface NominalValues {
	nominalValue?: number;
	nominalValuePerUnit?: number;
}

/**
 * Nominal value per unit after every split/reverse split. Falls back to the original
 * `nominalValue` when the backend had no holdings to compute it from.
 */
export const getCurrentNominalValue = (security: NominalValues): number | undefined =>
	security.nominalValuePerUnit || security.nominalValue;

/** Whether a split/reverse split moved the nominal value off the original, at display precision. */
export const hasSplitAdjustedNominalValue = (security: NominalValues): boolean =>
	getCurrentNominalValue(security)?.toFixed(SECURITY_NOMINAL_VALUE_PRECISION) !==
	security.nominalValue?.toFixed(SECURITY_NOMINAL_VALUE_PRECISION);

/** The as-of date the current nominal value was computed for; no picked date means today. */
export const formatNominalValueAsOfDate = (filterDate: Date | null) =>
	formatDateToUI(filterDate ?? new Date(), DATE_FORMATS.CALENDAR_DATE);
